<template>
    <div class="personnel-management">
        <!-- 搜索和筛选区域 -->
        <div class="search-panel">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="账号" class="form-item">
                    <el-input v-model="searchForm.name" placeholder="请输入账号" clearable class="search-input"
                        @keyup.enter="search"> <!-- 新增：回车搜索 -->
                    </el-input>
                </el-form-item>

                <el-form-item label="组织名称" class="form-item">
                    <el-select v-model="searchForm.orgId" placeholder="请选择组织名称" clearable class="search-select"
                        @change="search"> <!-- 新增：选择后自动搜索 -->
                        <el-option v-for="dept in departments" :key="dept.orgId" :label="dept.orgName"
                            :value="dept.orgId"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item class="form-item operate-btns">
                    <el-button type="primary" @click="search" class="search-btn">
                        <i class="fa fa-search mr-1"></i>搜索
                    </el-button>
                    <el-button type="default" @click="resetSearch" class="reset-btn">
                        重置
                    </el-button>
                    <el-button type="primary" @click="showAddDialog" class="add-btn">
                        <i class="fa fa-plus mr-2"></i>新增人员
                    </el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 人员表格 -->
        <div class="table-container">
            <el-table :data="pagedPersonnel" border stripe :header-cell-style="tableHeaderStyle"
                @selection-change="handleSelectionChange" class="personnel-table" v-loading="loading"
                element-loading-text="加载中..." element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" height="66vh">
                <el-table-column type="selection" width="55" align="center"></el-table-column>

                <el-table-column label="序号" type="index" width="60" align="center">
                    <template slot-scope="scope">
                        {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
                    </template>
                </el-table-column>

                <el-table-column prop="account" label="账号" min-width="130" align="center"></el-table-column>
                <el-table-column prop="realName" label="用户名" min-width="130" align="center"></el-table-column>
                <!-- 👇 这里是修改后的“组织名称”列 -->
                <el-table-column label="组织名称" min-width="150" align="center">
                    <template slot-scope="scope">
                        {{ getOrgNameById(scope.row.orgId) }}
                    </template>
                </el-table-column>
                <el-table-column label="角色名称" min-width="150" align="center">
                    <template slot-scope="scope">
                        {{ getOrgNameById1(scope.row.roleId) }}
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="120" align="center"></el-table-column>
                <el-table-column prop="phone" label="手机号" min-width="130" align="center"></el-table-column>

                <!-- 操作列保持不变 -->
                <el-table-column label="操作" min-width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" class="edit-btn" @click="openUploadDialog(scope.row)">
                            <i class="fa fa-pencil mr-1"></i>上传健康证
                        </el-button>
                        <el-button type="text" size="small" class="edit-btn" @click="confirmResetPwd(scope.row.userId)">
                            <i class="fa fa-pencil mr-1"></i>重置密码
                        </el-button>
                        <el-button type="text" size="small" class="edit-btn" @click="showEditDialog(scope.row)">
                            <i class="fa fa-pencil mr-1"></i>编辑
                        </el-button>
                        <el-button type="text" size="small" class="delete-btn" @click="handleDelete(scope.row.userId)">
                            <i class="fa fa-trash-o mr-1"></i>删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[5, 10, 20, 50]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="totalCount" class="pagination"
                :disabled="loading"></el-pagination>
        </div>

        <!-- 新增/编辑人员弹窗 -->
        <el-dialog :title="dialogType === 'add' ? '新增人员' : '编辑人员'" :visible.sync="dialogVisible" :width="dialogWidth"
            :close-on-click-modal="false" :z-index="3000" append-to-body>
            <el-form :model="form" :rules="formRules" ref="formRef" label-width="100px" class="form-modal">
                <el-row :gutter="20">
                    <!-- 账号输入框：支持编辑（移除了disabled属性） -->
                    <el-col :span="24" :sm="12">
                        <el-form-item label="账号" prop="account">
                            <el-input v-model="form.account" placeholder="请输入账号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :sm="12">
                        <el-form-item label="组织名称" prop="orgId">
                            <el-select v-model="form.orgId" placeholder="请选择组织名称">
                                <el-option v-for="dept in departments" :key="dept.orgId" :label="dept.orgName"
                                    :value="dept.orgId"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :sm="12">
                        <el-form-item label="角色名称" prop="roleId">
                            <el-select v-model="form.roleId" placeholder="请选择角色名称">
                                <el-option v-for="item in personnelList1" :key="item.id" :label="item.roleName"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- 密码输入框已移除 -->
                    <el-col :span="24" :sm="12">
                        <el-form-item label="用户名" prop="realName">
                            <el-input v-model="form.realName" placeholder="请输入用户名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :sm="12">
                        <el-form-item label="手机号" prop="phone">
                            <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" class="cancel-btn">取消</el-button>
                <el-button type="primary" @click="submitForm()" class="confirm-btn">确定</el-button>
            </div>
        </el-dialog>
        <!-- 上传健康证 -->
        <el-dialog title="上传健康证" :visible.sync="uploadDialogVisible" width="400px" :close-on-click-modal="false"
            append-to-body>
            <el-form :model="uploadForm" label-width="80px">
                <el-form-item label="选择文件">
                    <!-- 图片上传组件 -->
                    <el-upload class="avatar-uploader" :action="''" :auto-upload="false" :on-change="handleFileChange"
                        :file-list="fileList" accept=".png,.jpg,.jpeg,.pdf" :limit="1">
                        <img v-if="fileUrl" :src="fileUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <div class="el-upload__tip" slot="tip">
                        请上传png/jpg/jpeg/pdf格式的文件，大小不超过100k
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="uploadDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitUpload" :loading="uploadLoading">
                    确认上传
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getOrgList } from "@/api/organization";
import {
    addUser,
    getUserList,
    editUser,
    delUser,
    updateUserStatus,
    updatePassword, uploadHealthCertificate
} from "@/api/personnel";
import { getRoleList } from '@/api/role';
export default {

    data() {
        return {
            personnelList1: [],
            uploadDialogVisible: false,  // 上传弹窗显示状态
            uploadForm: {
                userId: '',  // 要上传的用户ID
                file: null   // 选中的文件对象
            },
            fileList: [],  // 上传文件列表
            fileUrl: '',   // 预览图片URL
            uploadLoading: false,  // 上传加载状态
            //  // 组织列表
            departments: [],
            positions: [

            ],

            // 人员数据
            personnelList: [], // 原始全量数据（接口返回）
            filteredPersonnel: [], // 筛选后列表
            pagedPersonnel: [], // 分页后列表
            totalCount: 0, // 总条数

            // 搜索表单
            searchForm: {
                name: null,// 账号搜索
                orgId: null, // 组织ID筛选
            },

            // 分页信息
            currentPage: 1,
            pageSize: 10,
            loading: false,

            // 选中的ID
            selectedIds: [],

            // 弹窗状态
            dialogVisible: false,
            dialogType: 'add',
            dialogWidth: '700px',

            // 表单数据（已移除password字段）
            form: {
                account: '', // 账号（可编辑）
                orgId: '', // 组织ID
                realName: '', // 用户名
                phone: '', // 手机号
                id: '', // 编辑时的用户ID
                roleId: ''
            },

            // 重置密码相关状态
            resetPwdDialogVisible: false,
            resetPwdUserId: '',
            resetPwdUserName: '',

            // 表单验证规则（已移除password相关规则）
            formRules: {
                account: [
                    { required: true, message: '请输入账号', trigger: 'blur' },
                    { min: 2, max: 20, message: '账号长度需在2-20字符之间', trigger: 'blur' },
                ],
                orgId: [
                    { required: true, message: '请选择组织名称', trigger: 'change' }
                ],
                realName: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                    { min: 2, max: 10, message: '用户名长度需在2-10字符之间', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的11位手机号', trigger: 'blur' }
                ],
            },

            // 表格样式
            tableHeaderStyle: {
                background: '#f5f7fa',
                color: '#1D2129',
                fontWeight: '500'
            }
        };
    },

    created() {
        // 初始化：先加载组织，再加载人员
        this.getOrgList(); this.getList()
    },

    methods: {   // 3. 获取角色列表
        getList() {
            return new Promise((resolve) => {
                this.loading = true;
                getRoleList({ userId: this.userId })
                    .then(response => {
                        this.personnelList1 = response.data || [];
                        // console.log(this.personnelList);

                    })
                    .catch(error => {
                        console.error('获取角色列表失败:', error);
                        const errorMsg = error.response?.data?.message || '加载角色列表失败';
                        this.$message.error(errorMsg);
                        this.personnelList = [];
                    })
                    .finally(() => {
                        this.loading = false;
                        resolve();
                    });
            });
        },
        getOrgNameById(orgId) {
            // 1. 若组织列表未加载，返回“加载中”
            if (!this.departments || this.departments.length === 0) {
                return "加载中...";
            }
            // 2. 遍历组织列表，匹配orgId
            const matchedOrg = this.departments.find(dept => dept.orgId === orgId);
            // 3. 有匹配返回orgName，无匹配返回“未知组织”（或原ID）
            return matchedOrg ? matchedOrg.orgName : '未知组织';
        }, getOrgNameById1(roleId) {
            // 1. 若组织列表未加载，返回“加载中”
            if (!this.personnelList1 || this.personnelList1.length === 0) {
                return "加载中...";
            }
            // 2. 遍历组织列表，匹配orgId
            const matchedOrg = this.personnelList1.find(dept => dept.roleId === roleId);
            // 3. 有匹配返回orgName，无匹配返回“未知组织”（或原ID）
            return matchedOrg ? matchedOrg.roleName : '未知角色';
        },
        // 1. 获取组织列表
        getOrgList() {
            this.loading = true;
            getOrgList({ tenantId: null }).then(response => {
                this.departments = response.data || [];
                this.getUserList()
            }).catch(error => {
                console.error('获取组织列表失败:', error);
                this.$message.error(error.response?.data?.message || '加载组织失败');
            }).finally(() => {
                this.loading = false;
            });
        },

        // 2. 获取人员列表（仅初始化/重置时调用，获取全量数据）
        getUserList() {
            this.loading = true;
            const params = {
                tenantId: null,
                // 清空搜索参数，获取全量数据
                account: null,
                orgId: null
            };

            getUserList(params).then(response => {
                const res = response.data || {};
                // 缓存全量原始数据
                this.personnelList = res.list || res || [];
                // 初始化过滤（显示全部）
                this.filterPersonnel();
            }).catch(error => {
                console.error('获取人员列表失败:', error);
                this.$message.error(error.response?.data?.message || '加载人员失败');
                this.personnelList = [];
                this.filteredPersonnel = [];
                this.pagedPersonnel = [];
                this.totalCount = 0;
            }).finally(() => {
                this.loading = false;
            });
        },

        // 新增：核心过滤方法（支持账号/组织单独/组合搜索）
        filterPersonnel() {
            let filtered = [...this.personnelList];

            // 1. 账号模糊搜索（忽略大小写）
            if (this.searchForm.name) {
                const keyword = this.searchForm.name.trim().toLowerCase();
                filtered = filtered.filter(item =>
                    item.account && item.account.toLowerCase().includes(keyword)
                );
            }

            // 2. 组织精确筛选
            if (this.searchForm.orgId) {
                filtered = filtered.filter(item =>
                    item.orgId === this.searchForm.orgId
                );
            }

            // 更新筛选后数据和总条数
            this.filteredPersonnel = filtered;
            this.totalCount = filtered.length;

            // 重新分页
            this.paginateData();
        },

        // 3. 分页处理（仅处理前端数据，不调用接口）
        paginateData() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.pagedPersonnel = this.filteredPersonnel.slice(startIndex, endIndex);
        },

        // 4. 搜索（仅执行前端过滤，不调用接口）
        search() {
            this.currentPage = 1; // 重置页码到第一页
            this.filterPersonnel(); // 执行前端过滤
        },

        // 5. 重置搜索
        resetSearch() {
            this.searchForm = {
                name: null,
                orgId: null,
            };
            this.currentPage = 1;
            // 重新获取全量数据（可选：也可直接调用filterPersonnel()）
            this.getUserList();
        },

        // 6. 显示新增弹窗
        showAddDialog() {
            this.dialogType = 'add';
            this.form = {
                account: '',
                orgId: '',
                realName: '',
                phone: '',
                id: '',
                roleId: '',
                password: '123456'
            };
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.formRef?.clearValidate();
            });
        },

        // 7. 显示编辑弹窗
        showEditDialog(row) {
            this.dialogType = 'edit';
            // 复制行数据到表单（不包含密码）
            this.form = {
                userId: localStorage.getItem('userId'),
                account: row.account, // 账号可编辑
                orgId: row.orgId,
                realName: row.realName,
                phone: row.phone,
                roleId: '',
                password: '123456'
            };
            this.dialogVisible = true;
            this.$nextTick(() => {
                this.$refs.formRef?.clearValidate();
            });
        },

        // 8. 提交表单（新增/编辑）
        submitForm() {
            this.$refs.formRef.validate(valid => {
                if (!valid) return;

                this.loading = true;
                const requestParams = { ...this.form };

                const requestFn = this.dialogType === 'add' ? addUser : editUser;

                requestFn(requestParams).then(response => {
                    if (response.success || response.code === 200) {
                        this.$message.success(`${this.dialogType === 'add' ? '新增' : '编辑'}成功`);
                        this.dialogVisible = false;
                        this.getUserList(); // 新增/编辑后重新获取全量数据
                    } else {
                        this.$message.error(response.message || `${this.dialogType === 'add' ? '新增' : '编辑'}失败`);
                    }
                }).catch(error => {
                    console.error(`${this.dialogType === 'add' ? '新增' : '编辑'}失败:`, error);
                    this.$message.error(error.response?.data?.message || '操作失败');
                }).finally(() => {
                    this.loading = false;
                });
            });
        },

        // 9. 单个删除
        handleDelete(id) {
            console.log(id);
            this.$confirm('确定删除该人员？删除后不可恢复', '确认删除', {
                type: 'warning',
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.loading = true;


                delUser({ userId: id }).then(response => {
                    if (response.success || response.code === 200) {
                        this.$message.success('删除成功');
                        this.getUserList(); // 删除后重新获取全量数据
                    } else {
                        this.$message.error(response.message || '删除失败');
                    }
                }).catch(error => {
                    console.error('删除失败:', error);
                    this.$message.error(error.response?.data?.message || '删除失败');
                }).finally(() => {
                    this.loading = false;
                });
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        // 10. 确认重置密码
        confirmResetPwd(userId) {
            this.$confirm('此操作将密码重置为123456, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true;
                updatePassword({
                    userId: userId,
                    newPassword: '123456'
                }).then(response => {
                    if (response.success || response.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '密码已重置为123456'
                        });
                        this.resetPwdDialogVisible = false;
                    } else {
                        this.$message.error(response.message || '密码重置失败');
                    }
                }).catch(error => {
                    console.error('重置密码失败:', error);
                    this.$message.error(error.response?.data?.message || '操作失败');
                }).finally(() => {
                    this.loading = false;
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消重置'
                });
            });
        },

        // 11. 状态切换
        handleStatusChange(row) {
            this.loading = true;
            updateUserStatus({
                id: row.id,
                status: row.status
            }).then(response => {
                if (!response.success && response.code !== 200) {
                    row.status = !row.status;
                    this.$message.error(response.message || '状态更新失败');
                } else {
                    this.$message.success(`已${row.status ? '启用' : '停用'}`);
                }
            }).catch(error => {
                row.status = !row.status;
                console.error('状态更新失败:', error);
                this.$message.error('状态更新失败');
            }).finally(() => {
                this.loading = false;
            });
        },

        // 12. 分页大小变更（仅前端处理）
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.paginateData(); // 重新分页，不调用接口
        },

        // 13. 页码变更（仅前端处理）
        handleCurrentChange(val) {
            this.currentPage = val;
            this.paginateData(); // 重新分页，不调用接口
        },

        // 14. 导出数据
        exportData() {
            this.loading = true;
            setTimeout(() => {
                this.$message.success('数据导出成功');
                this.loading = false;
            }, 800);
        },

        // 15. 处理表格选择
        handleSelectionChange(selection) {
            this.selectedIds = selection.map(item => item.id);
        },
        // 🔴 新增1：打开上传健康证弹窗
        openUploadDialog(row) {
            // 重置上传状态
            this.uploadDialogVisible = true;
            this.uploadForm.userId = row.userId;  // 绑定当前用户ID
            this.fileList = [];
            this.fileUrl = '';
            this.uploadForm.file = null;
        },

        // 🔴 新增2：处理文件选择变化
        handleFileChange(file, fileList) {
            // 限制文件大小（5MB）
            const isOverSize = file.size / 1024 / 1024 > 5;
            if (isOverSize) {
                this.$message.error('文件大小不能超过5MB！');
                this.fileList = [];
                return;
            }
            this.fileList = fileList;
            this.uploadForm.file = file.raw;  // 保存原始文件对象

            // 图片预览（仅图片格式）
            if (file.raw.type.indexOf('image') !== -1) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.fileUrl = e.target.result;
                };
                reader.readAsDataURL(file.raw);
            } else {
                this.fileUrl = '';  // 非图片（如PDF）不预览
            }
        },

        // 🔴 新增3：提交上传（调用接口）
        submitUpload() {
            // 校验：未选择文件
            if (!this.uploadForm.file) {
                this.$message.warning('请先选择要上传的健康证文件！');
                return;
            }

            this.uploadLoading = true;
            // 构建FormData（文件上传需用FormData格式）
            const formData = new FormData();
            formData.append('userId', this.uploadForm.userId);  // 用户ID
            formData.append('file', this.uploadForm.file);      // 上传文件

            // 调用上传接口
            uploadHealthCertificate(formData).then(response => {
                if (response.success || response.code === 200) {
                    this.$message.success('健康证上传成功！');
                    this.uploadDialogVisible = false;  // 关闭弹窗
                    this.getUserList();  // 刷新列表（若有健康证显示列可刷新）
                } else {
                    this.$message.error(response.message || '健康证上传失败');
                }
            }).catch(error => {
                console.error('上传健康证失败:', error);
                this.$message.error(error.response?.data?.message || '上传失败，请重试');
            }).finally(() => {
                this.uploadLoading = false;
            });
        },
    }
};
</script>

<style lang="scss" scoped>
.personnel-management {
    padding: 20px;
    // background-color: #f5f7fa;
    min-height: calc(100vh - 64px);

    .search-panel {
        background-color: #fff;
        border-radius: 4px;
        padding: 16px;
        margin-bottom: 24px;
        // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

        .search-form {
            display: flex;
            flex-wrap: wrap;
            gap: 16px;

            .form-item {
                margin-bottom: 0;

                &.operate-btns {
                    margin-left: auto;
                }
            }

            .search-input,
            .search-select {
                width: 200px;
            }

            .search-btn {
                background-color: #165dff;

                &:hover {
                    background-color: #0e4ada;
                }
            }

            .reset-btn {
                margin-left: 8px;
                background-color: #fff;
                // border-color: #dcdfe6;
                color: #606266;

                &:hover {
                    background-color: #f5f7fa;
                }
            }

            .add-btn {
                margin-left: 8px;
                background-color: #67c23a;

                &:hover {
                    background-color: #52c41a;
                }
            }
        }
    }

    .table-container {
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
        margin-bottom: 24px;

        .personnel-table {
            width: 100%;

            .edit-btn {
                color: #67c23a;

                &:hover {
                    color: #85ce61;
                }
            }

            .delete-btn {
                color: #f56c6c;

                &:hover {
                    color: #f78989;
                }
            }
        }
    }

    .pagination-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 10px 0;

        .pagination {
            margin: 0;
        }
    }

    .form-modal {
        margin-top: 16px;

        .form-tip {
            color: #86909c;
            font-size: 12px;
            margin-top: 4px;
        }
    }

    .dialog-footer {
        .cancel-btn {
            background-color: #fff;
            border-color: #dcdfe6;
            color: #606266;

            &:hover {
                background-color: #f5f7fa;
            }
        }

        .confirm-btn {
            background-color: #165dff;

            &:hover {
                background-color: #0e4ada;
            }
        }
    }
}

.avatar-uploader {
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
    border-radius: 4px;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    background-color: #fbfbfb;
}

.avatar-uploader:hover .avatar-uploader-icon {
    color: #409eff;
    border-color: #409eff;
}

// 响应式调整
@media (max-width: 768px) {
    .personnel-management {
        padding: 12px;

        .search-panel .search-form {

            .search-input,
            .search-select {
                width: 100%;
            }

            .form-item.operate-btns {
                margin-left: 0;
                width: 100%;
                justify-content: flex-end;
            }
        }

        .pagination-container {
            justify-content: center;
        }
    }
}
</style>